import React, { Fragment, useContext, useEffect, useState } from "react";
import { MdSave } from "react-icons/md";
import { useParams } from "react-router-dom";
import { getTokenData } from "../../../../../services/Auth__Service";
import { MOIS_TABS } from "../../../../../services/config";
import { findOne, save } from "../../../../../services/Share__Service";
import notifyContext from "../../../../Context/notifyContext";
import Loader from "../../../../Loader/Loader";

const FormShare = ({ shareId = 0, setReload }) => {
  const notify = useContext(notifyContext);
  const [error, setError] = useState("");
  const [isSend, setIsSend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [share, setShare] = useState({
    id: 0,
    mounth: 1,
    year: new Date().getFullYear(),
    statut: 1,
  });
  const [clientId, setClientId] = useState(0);
  const [annees, setAnnees] = useState([]);

  const paramsRoute = useParams();

  useEffect(() => {
    const tabs = [];
    for (let index = 2016; index <= new Date().getFullYear(); index++) {
      tabs.unshift(index);
    }

    setAnnees(tabs);
    setClientId(getTokenData().user_id);
  }, []);

  useEffect(() => {
    if (shareId > 0) {
      setIsLoading(true);
      fetchOneShare(shareId);
    }
  }, [shareId]);

  const fetchOneShare = async (id) => {
    findOne(id)
      .then((response) => {
        setShare(response.data);
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let display_errors = [];

    display_errors.map(({ message, id_input }, key) => {
      return (
        <label key={key} htmlFor={id_input}>
          {message}
        </label>
      );
    });

    setError(
      display_errors.map(({ message, id_input }, key) => {
        return (
          <label key={key} htmlFor={id_input}>
            {message}
          </label>
        );
      })
    );

    if (display_errors.length === 0) {
      setIsSend(true);
      setError(null);
      save({ ...share, clientId })
        .then(() => {
          setIsSend(false);
          setShare({
            id: 0,
            mounth: 1,
            year: new Date().getFullYear(),
            statut: 1,
          });
          setReload(true);
          notify("Enregistré avec succès", "success");
        })
        .catch((error) => {
          setIsSend(false);
          if (error.response.data.message !== undefined) {
            notify(error.response.data.message, "error");
          } else {
            notify("Problème au niveau du serveur", "error");
          }
        });
    }
  };

  const handleChange = (e) => {
    setShare((elt) => {
      return {
        ...elt,
        [e.target.name]: e.target.value,
      };
    });
  };
  useEffect(() => {
    if (error) {
      document.querySelector("form .error").scrollIntoView();
    }
  }, [error]);
  return (
    <Fragment>
      <form className="form" onSubmit={handleSubmit}>
        {error && error !== "" && (
          <div className="form-header">
            <div className="error">{error}</div>
          </div>
        )}

        <div className="form-body">
          <div className="form-group">
            <label htmlFor="mounth" className="form-label">
              Mois :
            </label>
            <select
              name="mounth"
              id="mounth"
              className="form-select"
              value={share.mounth}
              onChange={handleChange}
            >
              {MOIS_TABS.map((elt, key) => {
                return (
                  <option key={key} value={key + 1}>
                    {elt}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="year" className="form-label">
              Année :
            </label>
            <select
              name="year"
              id="year"
              className="form-select"
              value={share.year}
              onChange={handleChange}
            >
              {annees.map((elt, key) => {
                return (
                  <option key={key} value={elt}>
                    {elt}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <div className="form-footer">
          <button type="submit" className="btn">
            <MdSave />
            Enregistrer
          </button>
        </div>
      </form>

      {isSend && <Loader loadingMsg="En cours d'envoi" />}
      {isLoading && <Loader loadingMsg="Chargement..." />}
    </Fragment>
  );
};

export default FormShare;
